<template>
    <div class="margin_horizontal">
        <div class="pageTitle">
            <span class="md-title">{{ $t("management.contracts.title") }}</span>
        </div>
        <div class="table_description">
            <div class="tertiary_color text_left" v-html="$t('management.contracts.description')">
            </div>
        </div>
        <div class="flex">
            <div class="flex flex_column w_100">
                <ag-item :rowData="rowData"
                         :columnDefs="columnDefs"
						 :with-pagination="false"
                />
            </div>
        </div>
    </div>
</template>

<script>
import AgItem from "@/components/templates/agGrid/AgItem.vue";
import {enumDef} from "@/common/enumDefs";
import {exampleContractsApi} from "@/common/api/exampleContractsApi";

export default {
    components: {
        AgItem
    },
    data() {
        return {
            rowData: [],
            columnDefs: []
        };
    },
    beforeMount() {
        this.getColumnDef();
        this.getList();
    },
    methods: {
        getColumnDef() {
            this.columnDefs = [
                {
                    headerName: this.$t("management.contracts.table.header.contract"),
                    field: "contractName",
                    minWidth: 250,
                },
                {
                    headerName: this.$t("common.type"),
                    field: "type",
                    cellRendererFramework: "EnumAsText",
                    enumDef: enumDef.receivableType,
                    minWidth: 150,
                },
                {
                    headerName: this.$t("management.contracts.table.header.sampleFile"),
                    cellRendererFramework: "FileLink",
                    cellRendererParams: {
                        downloadUrlField: "url",
                        fileNameField: "linkName"
                    },
                    minWidth: 100
                },
            ];
        },
        getList() {
			const defaultData = {
				ipu: false,
				linkName: "PDF"
			};

            const data = [
				{
					...defaultData,
					contractName: this.$t("management.contracts.assignment_without_retention_and_disclosed"),
					type: enumDef.receivableType.SingleInvoice,
					retention: false,
					disclosed: true
				},
                {
					...defaultData,
                    contractName: this.$t("management.contracts.assignment_with_retention_and_disclosed"),
                    type: enumDef.receivableType.SingleInvoice,
                    retention: true,
                    disclosed: true
                },
				{
					...defaultData,
					contractName: this.$t("management.contracts.assignment_without_retention_and_undisclosed"),
					type: enumDef.receivableType.SingleInvoice,
					retention: false,
					disclosed: false
				},
                {
					...defaultData,
                    contractName: this.$t("management.contracts.assignment_with_retention_and_undisclosed"),
                    type: enumDef.receivableType.SingleInvoice,
                    retention: true,
                    disclosed: false
                },
				{
					...defaultData,
					contractName: this.$t("management.contracts.assignment_without_retention_and_disclosed"),
					type: enumDef.receivableType.InstallmentContractRate,
					retention: false,
					disclosed: true
				},
                {
					...defaultData,
                    contractName: this.$t("management.contracts.assignment_with_retention_and_disclosed"),
                    type: enumDef.receivableType.InstallmentContractRate,
                    retention: true,
                    disclosed: true
                },
            ];

            data.forEach(item => {
                item.url = exampleContractsApi.getAssignmentExampleContractDownloadUrl(item);
            });

            this.rowData = data;
        },
	}
};
</script>